export interface AdminPaths {
  DevReindexPage: string;
  ManageUnsubscribe: string;
  MassAdvisorUpdatePage: string;
  MassTagUpdatePage: string;
  MassAchievementUpdate: string;
}

export const adminPaths: AdminPaths = {
  DevReindexPage: '/admin/reindex',
  ManageUnsubscribe: '/admin/unsubscribe',
  MassAdvisorUpdatePage: '/admin/advisor-update',
  MassTagUpdatePage: '/admin/tag-update',
  MassAchievementUpdate: '/admin/achievement-update',
};
